import React from 'react';
import Typography from '@material-ui/core/Typography';

import './Header.css';

const Title = (props) => {
    return (
        <Typography component="h1" variant="h4" align="center">
            CtrlV T-Shirt Form
        </Typography>
    )
}

export default Title;